<ion-header class="mobile-header">
  <ion-toolbar brandingBackground="primaryColor">
    <ion-buttons slot="start">
      <ion-button size="small" color="white" fill="clear" (click)="goBack()">
        <ion-icon name="close-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title (click)="onHeaderTitleClick()">
      <div class="topDvCaption">
        <div class="title">
          <span class="title-text">{{activeMealPlan.title? activeMealPlan.title : ('mealPlanBuilder.newMealPlan' | translate)}}</span>
        </div>
        <div class="subtitle">
          <ng-container *ngIf="programMode !== 'menuLibrary'">
            <span class="subtitle-text">{{activeMealPlan.startDate | date}}<span *ngIf="activeMealPlan.endDate"> - {{activeMealPlan.endDate | date}}</span></span>
            <ion-icon name="calendar-outline"></ion-icon>
          </ng-container>
        </div>
      </div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button size="small" color="white" shape="round" (click)="showNotes()">
        <ion-icon slot="icon-only" name="list-outline"></ion-icon>
      </ion-button>
      <ion-button size="small" color="white" shape="round" [matMenuTriggerFor]="changesMenu" *ngIf="versionHistory?.length > 1 || hasDraft">
        <ion-icon slot="icon-only" name="arrow-undo-outline"></ion-icon>
      </ion-button>
      <ion-button size="small" fill="solid" color="success" shape="round" (click)="publishMealPlan()">
        {{(programMode === 'menuLibrary' ? 'general.save' : 'general.publish') | translate}}
      </ion-button>
    </ion-buttons>
    <mat-menu #changesMenu="matMenu" yPosition="below">
      <button mat-menu-item (click)="undoRevision()" *ngIf="versionHistory?.length > 1">{{'mealPlanBuilder.undoLastChange' | translate}}</button>
      <button mat-menu-item (click)="revertDraft()" *ngIf="hasDraft">{{'mealPlanBuilder.revertAllChanges' | translate}}</button>
    </mat-menu>
  </ion-toolbar>
  <ion-toolbar class="web-header active-plan" *ngIf="programMode !== 'menuLibrary'">
    <div class="plan-wrapper">
      <div class="plan-controls">
        <div class="plan-dropdown">
          <div class="plan-heading">
            <ng-container *ngIf="activeMealPlan?.plans?.length; else noMenusSubheading">
              {{'tabs.menu' | translate}} {{(activePlanIndex ?? 0) + 1}} / {{activeMealPlan.plans.length}}
            </ng-container>
            <ng-template #noMenusSubheading>{{'mealPlanBuilder.noMenusHeading' | translate}}</ng-template>
          </div>
          <button class="plan-dropdown-btn" type="button" (click)="openActivePlanDrawer()">
            <div class="plan-dropdown-title">
              <ng-container *ngIf="activeMealPlan?.plans?.length; else noMenuTitle">
                {{ activePlan?.title || ('mealPlanBuilder.menuWithNumber' | translate:{number: (activePlanIndex ?? 0) + 1}) }}
              </ng-container>
              <ng-template #noMenuTitle>{{'mealPlanBuilder.addMenuPrompt' | translate}}</ng-template>
            </div>
            <ion-icon [name]="isActivePlanPopoverOpen ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
          </button>
        </div>
        <div class="plan-segments header-meal-macro-tabs" *ngIf="(programType === 'user' || programMode === 'menuLibrary') && !isMacroPlan" role="tablist" [attr.aria-label]="'mealPlanBuilder.mealPlanViewAria' | translate">
          <button type="button" class="segment-btn" [class.active]="!isShown" (click)="setHeaderView('meals')">{{'mealPlanBuilder.mealView' | translate}}</button>
          <button type="button" class="segment-btn" [class.active]="isShown" (click)="setHeaderView('macros')">{{'mealPlanBuilder.planMacros' | translate}}</button>
        </div>
      </div>
    </div>
  </ion-toolbar>
  <!-- Targets bar (meal plan mode only: plan totals vs goals with progress bars; show only when all 4 targets set) -->
  <ion-toolbar class="mobile-macros-toolbar" *ngIf="activePlan && !isMacroPlan && !isActivePlanPopoverOpen && allMacroTargetsSet && !isShown">
    <div class="mobile-macros-toolbar-inner" *ngIf="calculatePlanTotal(activePlan) as planTotals">
      <div class="macro-labels-row">
        <span class="macro-toolbar-spacer"></span>
        <span class="macro-label macro-label-cell protein">PRO</span>
        <span class="macro-label macro-label-cell fat">FAT</span>
        <span class="macro-label macro-label-cell carbs">CAR</span>
        <span class="macro-label macro-label-cell calories">CAL</span>
      </div>
      <div class="macro-content-row">
        <span class="macro-toolbar-title">Targets:</span>
        <div class="macro-boxes-row">
          <div class="macro-block protein">
            <span class="macro-remaining"><span class="macro-total" [class.macro-value-over]="isOverMacroTarget(planTotals?.protein, activePlan?.goals?.protein)" [class.macro-value-ok]="activePlan?.goals?.protein != null && !isOverMacroTarget(planTotals?.protein, activePlan?.goals?.protein)">{{(planTotals?.protein ?? 0) | number:'1.0-0'}}</span>/{{activePlan?.goals?.protein != null ? (activePlan.goals.protein | number:'1.0-0') + 'g' : '—'}}</span>
            <div class="macro-progress-track">
              <div class="macro-progress-fill" [style.width.%]="getMacroProgressPercent(planTotals?.protein ?? 0, activePlan?.goals?.protein)"></div>
            </div>
          </div>
          <div class="macro-block fat">
            <span class="macro-remaining"><span class="macro-total" [class.macro-value-over]="isOverMacroTarget(planTotals?.fat, activePlan?.goals?.fat)" [class.macro-value-ok]="activePlan?.goals?.fat != null && !isOverMacroTarget(planTotals?.fat, activePlan?.goals?.fat)">{{(planTotals?.fat ?? 0) | number:'1.0-0'}}</span>/{{activePlan?.goals?.fat != null ? (activePlan.goals.fat | number:'1.0-0') + 'g' : '—'}}</span>
            <div class="macro-progress-track">
              <div class="macro-progress-fill" [style.width.%]="getMacroProgressPercent(planTotals?.fat ?? 0, activePlan?.goals?.fat)"></div>
            </div>
          </div>
          <div class="macro-block carbs">
            <span class="macro-remaining"><span class="macro-total" [class.macro-value-over]="isOverMacroTarget(planTotals?.carbs, activePlan?.goals?.carbs)" [class.macro-value-ok]="activePlan?.goals?.carbs != null && !isOverMacroTarget(planTotals?.carbs, activePlan?.goals?.carbs)">{{(planTotals?.carbs ?? 0) | number:'1.0-0'}}</span>/{{activePlan?.goals?.carbs != null ? (activePlan.goals.carbs | number:'1.0-0') + 'g' : '—'}}</span>
            <div class="macro-progress-track">
              <div class="macro-progress-fill" [style.width.%]="getMacroProgressPercent(planTotals?.carbs ?? 0, activePlan?.goals?.carbs)"></div>
            </div>
          </div>
          <div class="macro-block calories">
            <span class="macro-remaining"><span class="macro-total" [class.macro-value-over]="isOverMacroTarget(planTotals?.calories, activePlan?.goals?.calories)" [class.macro-value-ok]="activePlan?.goals?.calories != null && !isOverMacroTarget(planTotals?.calories, activePlan?.goals?.calories)">{{formatCalories(planTotals?.calories ?? 0)}}</span>/{{activePlan?.goals?.calories != null ? formatCalories(activePlan.goals.calories) : '—'}}</span>
            <div class="macro-progress-track">
              <div class="macro-progress-fill" [style.width.%]="getMacroProgressPercent(planTotals?.calories ?? 0, activePlan?.goals?.calories)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ion-toolbar>
  <!-- Set target macros button (when not all 4 targets set) -->
  <ion-toolbar class="mobile-macros-set-target-toolbar" *ngIf="activePlan && !isMacroPlan && !isActivePlanPopoverOpen && !allMacroTargetsSet && !isShown">
    <ion-button expand="block" color="secondary" fill="outline" size="small" (click)="setHeaderView('macros')">
      {{ 'mealPlanBuilder.setTargetMacros' | translate }}
    </ion-button>
  </ion-toolbar>
 <!-- <ion-toolbar class="web-header macro-progress-toolbar" *ngIf="!isActivePlanPopoverOpen && activePlan?.goals && calculatePlanTotal(activePlan) as planTotals">
    <div class="macro-progress-grid">
      <div class="macro-progress-item protein">
        <div class="macro-progress-head">
          <span class="macro-label">PRO</span>
          <span class="macro-value">{{planTotals.protein | number:'1.0-0'}}/{{(activePlan.goals.protein || 0) | number:'1.0-0'}}</span>
        </div>
        <div class="macro-track">
          <span class="macro-fill" [style.width.%]="getMacroProgressPercent(planTotals.protein, activePlan.goals.protein)"></span>
        </div>
      </div>

      <div class="macro-progress-item fat">
        <div class="macro-progress-head">
          <span class="macro-label">FAT</span>
          <span class="macro-value">{{planTotals.fat | number:'1.0-0'}}/{{(activePlan.goals.fat || 0) | number:'1.0-0'}}</span>
        </div>
        <div class="macro-track">
          <span class="macro-fill" [style.width.%]="getMacroProgressPercent(planTotals.fat, activePlan.goals.fat)"></span>
        </div>
      </div>

      <div class="macro-progress-item carbs">
        <div class="macro-progress-head">
          <span class="macro-label">CAR</span>
          <span class="macro-value">{{planTotals.carbs | number:'1.0-0'}}/{{(activePlan.goals.carbs || 0) | number:'1.0-0'}}</span>
        </div>
        <div class="macro-track">
          <span class="macro-fill" [style.width.%]="getMacroProgressPercent(planTotals.carbs, activePlan.goals.carbs)"></span>
        </div>
      </div>

      <div class="macro-progress-item calories">
        <div class="macro-progress-head">
          <span class="macro-label">CAL</span>
          <span class="macro-value">{{planTotals.calories | number:'1.0-0'}}/{{(activePlan.goals.calories || 0) | number:'1.0-0'}}</span>
        </div>
        <div class="macro-track">
          <span class="macro-fill" [style.width.%]="getMacroProgressPercent(planTotals.calories, activePlan.goals.calories)"></span>
        </div>
      </div>
    </div>
  </ion-toolbar>-->
  <ion-toolbar class="web-header plan-inline-toolbar" [class.is-open]="isActivePlanPopoverOpen" *ngIf="programMode !== 'menuLibrary'">
    <div class="active-plan-inline-panel">
      <div class="active-plan-popover" cdkDropList [cdkDropListData]="activeMealPlan.plans" (cdkDropListDropped)="onPlanReordered($event)">
        <div
          class="popover-option"
          cdkDrag
          *ngFor="let plan of activeMealPlan.plans; let i = index"
          [class.active]="i === activePlanIndex"
          (click)="onPlanSelected(i)">
          <span class="drag-handle" cdkDragHandle>
            <ion-icon name="reorder-two-outline"></ion-icon>
          </span>

          <div class="option-content">
            <div class="option-title">{{ plan?.title || ('mealPlanBuilder.menuWithNumber' | translate:{number: (i + 1)}) }}</div>
            <div class="option-subtitle">{{getPlanCalories(plan) | number:'1.0-0'}} {{'general.calories' | translate}}</div>
          </div>

          <div class="option-actions">
            <span *ngIf="i === activePlanIndex" class="option-check-circle">
              <ion-icon class="option-check" name="checkmark-outline"></ion-icon>
            </span>

            <button
              type="button"
              class="option-menu-btn"
              mat-icon-button
              stop-propagation
              [matMenuTriggerFor]="planOptionsMenu">
              <ion-icon name="ellipsis-vertical-outline"></ion-icon>
            </button>

            <mat-menu #planOptionsMenu="matMenu" yPosition="below">
              <button mat-menu-item (click)="editPlanFromMenu(i)">{{'general.editTitle' | translate}}</button>
              <button mat-menu-item (click)="duplicatePlanFromMenu(i)">{{'general.duplicatePlan' | translate}}</button>
              <button mat-menu-item (click)="saveMenuToLibrary(i)" *ngIf="organization?.isUserTrainer(activeUser?.uid) && !isMacroPlan">{{'mealPlanBuilder.saveMenuToLibrary' | translate}}</button>
              <button mat-menu-item (click)="deletePlanFromMenu(i)">{{'general.deletePlan' | translate}}</button>
            </mat-menu>
          </div>
        </div>

        <div class="ion-text-center ion-padding">
          <ion-button
            color="secondary"
            fill="solid"
            shape="round"
            [matMenuTriggerFor]="addMenuOptionsPopover"
            *ngIf="!isMacroPlan">
            <ion-icon slot="start" name="add-outline"></ion-icon>
            <span>{{'general.menu' | translate}}</span>
          </ion-button>
          <ion-button
            color="secondary"
            fill="solid"
            shape="round"
            (click)="addBlankPlan()"
            *ngIf="isMacroPlan">
            <ion-icon slot="start" name="add-outline"></ion-icon>
            <span>{{'general.menu' | translate}}</span>
          </ion-button>
          <mat-menu #addMenuOptionsPopover="matMenu" yPosition="below">
            <button mat-menu-item (click)="onCreateBlankPlanFromPopover()">
              <span>{{'mealPlanBuilder.addBlankMenu' | translate}}</span>
            </button>
            <button mat-menu-item (click)="addPlanFromLibrary()" *ngIf="organization?.isUserTrainer(activeUser?.uid) && !isMacroPlan">
              <span>{{'mealPlanBuilder.fromLibrary' | translate}}</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  </ion-toolbar>
</ion-header>

<ng-container *ngIf="!comparePaneEmbedded; else embeddedMealBuilderContent">
  <ion-content id="content-mp-builder" class="ion-padding">
    <ng-container *ngTemplateOutlet="mealBuilderContent"></ng-container>
  </ion-content>
</ng-container>
<ng-template #embeddedMealBuilderContent>
  <div class="ion-padding compare-pane-embedded-content" id="content-mp-builder">
    <ng-container *ngTemplateOutlet="mealBuilderContent"></ng-container>
  </div>
</ng-template>

<ng-template #mealBuilderContent>
  <div class="content">
    <div class="desktop-sticky-shell ion-hide-lg-down">
      <div class="web-header">
      <div class="left">
        <div class="backBtnTopPanel">
          <div>
            <h2 class="title" (click)="onHeaderTitleClick()">
              {{activeMealPlan.title? activeMealPlan.title : ('mealPlanBuilder.newMealPlan' | translate)}}
            </h2>

            <!-- ⭐ NEW DATE ROW HERE -->
            <div class="date-row" *ngIf="programMode !== 'menuLibrary'">

              <span class="date" (click)="editDate($event, 'startDate')">
                {{ activeMealPlan.startDate | date:'MMM d, y' }}
              </span>

              <span class="separator">–</span>

              <span class="date" [class.placeholder]="!activeMealPlan.endDate" (click)="editDate($event, 'endDate')">
                <ng-container *ngIf="activeMealPlan.endDate; else addEndDate">
                  {{ activeMealPlan.endDate | date:'MMM d, y' }}
                </ng-container>
                <ng-template #addEndDate>
                  {{'mealPlanBuilder.addEndDate' | translate}}
                </ng-template>
              </span>
              <ion-icon name="calendar-outline"></ion-icon>
            </div>
          </div>
      
        </div>
      </div>
      <div class="right">
        <ion-button size="small" (click)="undoRevision()" *ngIf="versionHistory?.length > 1">
          <ion-icon name="arrow-undo-outline"></ion-icon> <span>{{'general.undo' | translate}}</span>
        </ion-button>
        <ion-button size="small" (click)="revertDraft()" *ngIf="hasDraft">
          <ion-icon name="arrow-undo-outline"></ion-icon> <span>{{'general.revert' | translate}}</span>
        </ion-button>
        <ion-button size="small" class="notes-btn" (click)="showNotes()">
          <ion-icon name="list-outline"></ion-icon><span> {{'general.notes' | translate}}</span>
        </ion-button>
        <ion-button size="small" color="success" (click)="publishMealPlan()">
          <ion-icon name="save-outline"></ion-icon> {{'general.publish' | translate}}
        </ion-button>
        <ion-button size="small" class="settings-btn" fill="clear" (click)="goBack()">
          <ion-icon name="close-outline" slot="icon-only"></ion-icon>
        </ion-button>
      </div>
      </div>

      <!-- Desktop (lg+): meal vs macros tabs live in scrollable content (header pills hidden via CSS). -->
      <div
        class="content-meal-macro-tabs"
        *ngIf="(programType === 'user' || programMode === 'menuLibrary') && !isMacroPlan"
        role="tablist"
        [attr.aria-label]="'mealPlanBuilder.mealPlanViewAria' | translate">
        <div class="content-segment-group">
          <button type="button" class="segment-btn" [class.active]="!isShown" (click)="setHeaderView('meals')">
            {{'mealPlanBuilder.mealView' | translate}}
          </button>
          <button type="button" class="segment-btn" [class.active]="isShown" (click)="setHeaderView('macros')">
            {{'mealPlanBuilder.planMacros' | translate}}
          </button>
        </div>
        <div class="web-macros-toolbar" *ngIf="activePlan">
          <span class="macro-toolbar-title">Targets:</span>
          <div class="macro-boxes-row" *ngIf="allMacroTargetsSet && calculatePlanTotal(activePlan) as planTotals; else webMacrosEmptyState">
            <div class="macro-block protein">
              <span class="macro-label">PRO</span>
              <span class="macro-remaining"><span class="macro-total" [class.macro-value-over]="isOverMacroTarget(planTotals?.protein, activePlan?.goals?.protein)" [class.macro-value-ok]="activePlan?.goals?.protein != null && !isOverMacroTarget(planTotals?.protein, activePlan?.goals?.protein)">{{(planTotals?.protein ?? 0) | number:'1.0-0'}}</span>/{{activePlan?.goals?.protein != null ? (activePlan.goals.protein | number:'1.0-0') + 'g' : '—'}}</span>
              <div class="macro-progress-track">
                <div class="macro-progress-fill" [style.width.%]="getMacroProgressPercent(planTotals?.protein ?? 0, activePlan?.goals?.protein)"></div>
              </div>
            </div>
            <div class="macro-block fat">
              <span class="macro-label">FAT</span>
              <span class="macro-remaining"><span class="macro-total" [class.macro-value-over]="isOverMacroTarget(planTotals?.fat, activePlan?.goals?.fat)" [class.macro-value-ok]="activePlan?.goals?.fat != null && !isOverMacroTarget(planTotals?.fat, activePlan?.goals?.fat)">{{(planTotals?.fat ?? 0) | number:'1.0-0'}}</span>/{{activePlan?.goals?.fat != null ? (activePlan.goals.fat | number:'1.0-0') + 'g' : '—'}}</span>
              <div class="macro-progress-track">
                <div class="macro-progress-fill" [style.width.%]="getMacroProgressPercent(planTotals?.fat ?? 0, activePlan?.goals?.fat)"></div>
              </div>
            </div>
            <div class="macro-block carbs">
              <span class="macro-label">CAR</span>
              <span class="macro-remaining"><span class="macro-total" [class.macro-value-over]="isOverMacroTarget(planTotals?.carbs, activePlan?.goals?.carbs)" [class.macro-value-ok]="activePlan?.goals?.carbs != null && !isOverMacroTarget(planTotals?.carbs, activePlan?.goals?.carbs)">{{(planTotals?.carbs ?? 0) | number:'1.0-0'}}</span>/{{activePlan?.goals?.carbs != null ? (activePlan.goals.carbs | number:'1.0-0') + 'g' : '—'}}</span>
              <div class="macro-progress-track">
                <div class="macro-progress-fill" [style.width.%]="getMacroProgressPercent(planTotals?.carbs ?? 0, activePlan?.goals?.carbs)"></div>
              </div>
            </div>
            <div class="macro-block calories">
              <span class="macro-label">CAL</span>
              <span class="macro-remaining"><span class="macro-total" [class.macro-value-over]="isOverMacroTarget(planTotals?.calories, activePlan?.goals?.calories)" [class.macro-value-ok]="activePlan?.goals?.calories != null && !isOverMacroTarget(planTotals?.calories, activePlan?.goals?.calories)">{{formatCalories(planTotals?.calories ?? 0)}}</span>/{{activePlan?.goals?.calories != null ? formatCalories(activePlan.goals.calories) : '—'}}</span>
              <div class="macro-progress-track">
                <div class="macro-progress-fill" [style.width.%]="getMacroProgressPercent(planTotals?.calories ?? 0, activePlan?.goals?.calories)"></div>
              </div>
            </div>
          </div>
          <ng-template #webMacrosEmptyState>
            <div class="web-macros-empty">
              <ion-button class="configure-macros-btn" size="small" color="secondary" fill="outline" (click)="setHeaderView('macros')">
                {{'mealPlanBuilder.setTargetMacros' | translate}}
              </ion-button>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <ion-grid>
      <ion-row>
        <ion-col size="12" class="mobileMarcoContent" [class.showCalc]="isShown"
          *ngIf="programType === 'user' || programMode === 'menuLibrary'">
          <div class="mealRightDetailPanel side-panel">
            <div class="macroCalHeading">
              <div class="marcoCalHeading__left">
                {{'general.macroCalculator' | translate}}
              </div>
              <div class="marcoCalHeading__right" (click)="openCalc()">
                <ion-icon name="close-outline" class="popupCloseIcon"></ion-icon>
              </div>
            </div>

            <div class="macro-details-grid" [class.has-user-details]="programType === 'user'">
              <!-- Plan Macros Table Section -->
              <div class="target-macros-table" *ngIf="activePlan?.goals && calculatePlanTotal(activePlan) && activeMealPlan?.type !== 'macro'">
                <div class="macros-table-header">{{'mealPlanBuilder.planMacros' | translate}}</div>
                <div class="macros-table-wrapper">
                  <div class="table-row header-row">
                    <div class="col col-label"></div>
                    <div class="col col-target"><span>{{'general.target' | translate}}</span><span>{{'general.macros' | translate}}</span></div>
                    <div class="col col-percent"><span>{{'general.macros' | translate}}</span><span>%</span></div>
                    <div class="col col-remaining"><span>{{'mealPlanBuilder.remainingAbbrev' | translate}}</span><span>{{'general.macros' | translate}}</span></div>
                  </div>
                  <div class="table-row" *ngFor="let macro of getTargetMacrosRemaining(); let i = index; trackBy: trackByMacroLabel">
                    <div class="col col-label">{{macro.label === 'Proteins' ? ('general.proteins' | translate) : (macro.label === 'Fats' ? ('general.fats' | translate) : (macro.label === 'Carbs' ? ('general.carbs' | translate) : ('general.calories' | translate)))}}</div>
                    <div class="col col-target">
                      <ng-container *ngIf="macro.label === 'Calories'; else targetInput">
                        <span class="target-value-readonly">{{activePlan.goals?.calories ?? 0 | number:'1.0-0'}}</span>
                      </ng-container>
                      <ng-template #targetInput>
                        <input type="number" inputmode="numeric" pattern="[0-9]*" step="1" class="target-input" 
                                [value]="macro.label === 'Proteins' ? activePlan.goals.protein : (macro.label === 'Fats' ? activePlan.goals.fat : activePlan.goals.carbs)"
                                (input)="updateTargetMacro(macro.label, $event)"
                                (blur)="saveMealPlan()">
                        <span class="target-unit">g</span>
                      </ng-template>
                    </div>
                    <div class="col col-percent">{{macro.percentage}}</div>
                    <div class="col col-remaining" [class.negative]="macro.remainingNum < 0">{{macro.remaining}}</div>
                  </div>
                </div>
              </div>
              
              <!-- User details form -->
              <div class="user-details-panel" *ngIf="programType === 'user'">
                <div class="user-details-header">
                  <h4 class="user-details-title" [class.incomplete]="!hasRequiredUserStats()">{{'general.userDetails' | translate}}</h4>
                  <ion-button fill="clear" size="small" (click)="toggleUserDetails()" class="collapse-btn">
                    <ion-icon [name]="userDetailsCollapsed ? 'chevron-down-outline' : 'chevron-up-outline'"></ion-icon>
                  </ion-button>
                </div>
                <p class="user-details-note" *ngIf="!userDetailsCollapsed">
                  {{'mealPlanBuilder.fillDetailsForBmr' | translate}}
                </p>

                <form name="userDetailsForm" #userDetailsForm="ngForm">
                  <ion-grid>
                    <!-- Collapsible Fields Section -->
                    <div class="collapsible-fields" [class.collapsed]="userDetailsCollapsed">
                      <ion-row>
                        <ion-col size="6">
                          <ion-item class="ion-no-padding" [class.field-incomplete]="isFieldIncomplete('age')">
                            <ion-label position="stacked">{{'general.age' | translate}} ({{'general.years' | translate}})</ion-label>
                            <ion-input type="number" name="age" #age="ngModel" [(ngModel)]="activeMealPlan.stats.age"
                              (ionInput)="setUserDetails()" (change)="saveMealPlan()" required></ion-input>
                          </ion-item>
                        </ion-col>
                        <ion-col size="6">
                          <ion-item class="ion-no-padding" [class.field-incomplete]="isFieldIncomplete('gender')">
                            <ion-label position="stacked">{{'general.gender' | translate}}</ion-label>
                            <ion-select name="gender" [(ngModel)]="activeMealPlan.stats.gender"
                              (ionChange)="setUserDetails()" required>
                              <ion-select-option value="female">{{'general.female' | translate}}</ion-select-option>
                              <ion-select-option value="male">{{'general.male' | translate}}</ion-select-option>
                            </ion-select>
                          </ion-item>
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col size="6">
                          <ion-item class="ion-no-padding" [class.field-incomplete]="isFieldIncomplete('height')">
                            <ion-label position="stacked">{{'general.height' | translate}} ({{activeUnit === 'metric'? 'cm' : 'in'}})</ion-label>
                            <ion-input type="number" name="height" [(ngModel)]="activeMealPlan.stats.height"
                              (ionInput)="setUserDetails()" (change)="saveMealPlan()" required></ion-input>
                          </ion-item>
                        </ion-col>
                        <ion-col size="6">
                          <ion-item class="ion-no-padding" [class.field-incomplete]="isFieldIncomplete('weight')">
                            <ion-label position="stacked">{{'general.weight' | translate}} ({{(activeUnit === 'metric' ? 'general.kg' : 'general.lbs') | translate}})</ion-label>
                            <ion-input type="number" name="weight" [(ngModel)]="activeMealPlan.stats.weight"
                              (ionInput)="setUserDetails()" (change)="saveMealPlan()" required></ion-input>
                          </ion-item>
                        </ion-col>
                      </ion-row>
                    </div>

                    <!-- BMR Card (Full Width) - Always Visible -->
                    <ion-row>
                      <ion-col size="12">
                        <div class="stat-card-full bmr-card">
                          <div class="stat-label">{{'mealPlanBuilder.bmr' | translate}}</div>
                          <div class="stat-value" *ngIf="activeMealPlan?.stats?.bmr">{{activeMealPlan.stats.bmr | number: '1.0-0'}}</div>
                          <div class="stat-value" *ngIf="!activeMealPlan?.stats?.bmr">{{'mealPlanBuilder.na' | translate}}</div>
                          <div class="stat-unit">{{'mealPlanBuilder.kcal' | translate}}</div>
                        </div>
                      </ion-col>
                    </ion-row>

                    <!-- Collapsible Fields Section Continued -->
                    <div class="collapsible-fields" [class.collapsed]="userDetailsCollapsed">
                      <ion-row>
                        <ion-col size="12">
                          <ion-item class="ion-no-padding" [class.field-incomplete]="isFieldIncomplete('bodyType')">
                            <ion-label position="stacked">{{'general.bodyType' | translate}}</ion-label>
                            <mat-select class="formControl" #bodyType="ngModel"
                              [(ngModel)]="activeMealPlan.stats.bodyType" (selectionChange)="setUserDetails()"
                              name="bodyType" required>
                              <mat-option value="ectomorph">{{'general.ectomorph' | translate}}</mat-option>
                              <mat-option value="mesomorph">{{'general.mesomorph' | translate}}</mat-option>
                              <mat-option value="endomorph">{{'general.endomorph' | translate}}</mat-option>
                            </mat-select>
                          </ion-item>
                        </ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col size="12">
                          <ion-item class="ion-no-padding" [class.field-incomplete]="isFieldIncomplete('activity')">
                            <ion-label position="stacked">{{'general.activityLevel' | translate}}</ion-label>
                            <mat-select class="formControl" #activityLevel="ngModel"
                              [(ngModel)]="activeMealPlan.stats.activity" (selectionChange)="setUserDetails()"
                              name="activityLevel" required>
                              <mat-option [value]="1.2">{{'general.sedentary' | translate}}</mat-option>
                              <mat-option [value]="1.375">{{'general.lightlyActive' | translate}}</mat-option>
                              <mat-option [value]="1.465">{{'general.moderatelyActive' | translate}}</mat-option>
                              <mat-option [value]="1.55">{{'general.active' | translate}}</mat-option>
                              <mat-option [value]="1.75">{{'general.veryActive' | translate}}</mat-option>
                              <mat-option [value]="1.9">{{'general.superActive' | translate}}</mat-option>
                            </mat-select>
                          </ion-item>
                        </ion-col>
                      </ion-row>
                    </div>

                    <!-- Maintenance Card (Full Width) -->
                    <ion-row>
                      <ion-col size="12">
                        <div class="stat-card-full maintenance-card">
                          <div class="stat-label">{{'general.maintenance' | translate}}</div>
                          <div class="stat-value" *ngIf="activeMealPlan?.stats?.maintenance">{{activeMealPlan.stats.maintenance | number: '1.0-0'}}</div>
                          <div class="stat-value" *ngIf="!activeMealPlan?.stats?.maintenance">{{'mealPlanBuilder.na' | translate}}</div>
                          <div class="stat-unit">{{'mealPlanBuilder.kcal' | translate}}</div>
                        </div>
                      </ion-col>
                    </ion-row>

                    <!-- Plan Deficit/Surplus Card -->
                    <ion-row *ngIf="activeMealPlan?.stats?.maintenance && activePlan?.goals?.calories">
                      <ion-col size="12">
                        <div class="stat-card-full deficit-surplus-card" 
                             [class.surplus]="activePlan.goals.calories - activeMealPlan.stats.maintenance > 0"
                             [class.deficit]="activePlan.goals.calories - activeMealPlan.stats.maintenance <= 0">
                          <div class="stat-label">
                            <ion-icon [name]="activePlan.goals.calories - activeMealPlan.stats.maintenance > 0 ? 'trending-up-outline' : 'trending-down-outline'"></ion-icon>
                            {{activePlan.goals.calories - activeMealPlan.stats.maintenance > 0 ? ('mealPlanBuilder.surplus' | translate) : ('mealPlanBuilder.deficit' | translate)}}
                          </div>
                          <div class="stat-value">{{getDeficit()}}</div>
                          <div class="stat-unit">{{'mealPlanBuilder.cals' | translate}}</div>
                        </div>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </form>
              </div>
            </div>

          </div>
        </ion-col>
        <ion-col size="12" class="customCol-9" [class.hide-on-mobile]="(programType === 'user' || programMode === 'menuLibrary') && isShown && !isMacroPlan">
          <div *ngIf="activeMealPlan.plans && activeMealPlan.plans.length > 0">
            <div class="navDiv m-hide" *ngIf="programMode !== 'menuLibrary'">
              <div class="etTabsWrapper">
                <nav class="et-tabs" backgroundColor="blue" cdkDropList cdkDropListOrientation="horizontal"
                (cdkDropListDropped)="drop($event)" appHorizontalScroll>
                <a class="tab" cdkDrag [cdkDragDisabled]="activePlanIndex !== i"
                  *ngFor="let plan of activeMealPlan.plans; let i = index;" (click)="setActivePlan(i)"
                  [class.active]="activePlanIndex === i">
                  {{plan.title}}
                  <span class="action" *ngIf="activePlanIndex === i" mat-button [matMenuTriggerFor]="menu">
                    <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                  </span>
                  <mat-menu #menu="matMenu" yPosition="below">
                    <button mat-menu-item (click)="editPlanTitle()">{{'general.editTitle' | translate}}</button>
                    <button mat-menu-item (click)="duplicatePlan(i)">{{'general.duplicatePlan' | translate}}</button>
                    <button mat-menu-item (click)="saveMenuToLibrary(i)" *ngIf="organization?.isUserTrainer(activeUser?.uid) && !isMacroPlan">{{'mealPlanBuilder.saveMenuToLibrary' | translate}}</button>
                    <button mat-menu-item (click)="deletePlan()">{{'general.deletePlan' | translate}}</button>
                  </mat-menu>
                  <span class="moveDiv" *ngIf="activePlanIndex === i" cdkDragHandle>
                    <ion-icon name="swap-horizontal-outline"></ion-icon>
                  </span>
                </a>
                <ion-button size="small" color="secondary" type="button" [matMenuTriggerFor]="addMenuOptionsDesktop" *ngIf="!isMacroPlan">
                  <ion-icon name="add-outline"></ion-icon> {{'general.menu' | translate}}
                </ion-button>
                <ion-button size="small" color="secondary" type="button" (click)="addBlankPlan()" *ngIf="isMacroPlan">
                  <ion-icon name="add-outline"></ion-icon> {{'general.menu' | translate}}
                </ion-button>
                <mat-menu #addMenuOptionsDesktop="matMenu" yPosition="below">
                  <button mat-menu-item (click)="addBlankPlan()">
                    <span>{{'mealPlanBuilder.addBlankMenu' | translate}}</span>
                  </button>
                  <button mat-menu-item (click)="addPlanFromLibrary()" *ngIf="organization?.isUserTrainer(activeUser?.uid) && !isMacroPlan">
                    <span>{{'mealPlanBuilder.fromLibrary' | translate}}</span>
                  </button>
                </mat-menu>
              </nav>
              </div>
            </div>


            <!-- Macro Plan Builder Section (shown only for macro plans) -->
            <div class="switchTabsDv macro-plan-builder" *ngIf="activePlan && activePlan.goals && activeMealPlan.type === 'macro'">
              <div class="switchTabsInner">
                <div class="macro-targets-section">
                  <div class="macro-targets-header">
                    <div class="builder-section-title">
                      {{'mealPlanBuilder.macroTargets' | translate}}
                    </div>
                  </div>
                  
                  <!-- Macro Targets Table (moved from sidebar) -->
                  <div class="macro-targets-table-container">
                    <div class="macros-section">
                      <div class="macro-cards-grid">
                        <!-- Proteins Card -->
                        <div class="macro-card protein-card">
                          <div class="card-decoration"></div>
                          <div class="card-header">
                            <div class="macro-icon">
                              <ion-icon name="barbell-outline"></ion-icon>
                            </div>
                            <h4>{{'general.proteins' | translate}}</h4>
                          </div>
                          <div class="card-body">
                            <div class="input-row">
                              <div class="input-wrapper">
                                <input type="number" inputmode="numeric" [(ngModel)]="activePlan.goals.protein" (change)="saveMealPlan()" (ngModelChange)="macroChanged()" class="macro-input" placeholder="0">
                                <span class="input-unit">g</span>
                              </div>
                              <div class="percentage-display">
                                <span class="percentage-value" *ngIf="activePlan.goals?.calories">{{(((activePlan.goals.protein ?? 0) * 4) / activePlan.goals.calories * 100) || 0 | number: '1.0-0'}}%</span>
                                <span class="percentage-value" *ngIf="!activePlan.goals?.calories">0%</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Fats Card -->
                        <div class="macro-card fats-card">
                          <div class="card-decoration"></div>
                          <div class="card-header">
                            <div class="macro-icon">
                              <ion-icon name="water-outline"></ion-icon>
                            </div>
                            <h4>{{'general.fats' | translate}}</h4>
                          </div>
                          <div class="card-body">
                            <div class="input-row">
                              <div class="input-wrapper">
                                <input type="number" inputmode="numeric" [(ngModel)]="activePlan.goals.fat" (change)="saveMealPlan()" (ngModelChange)="macroChanged()" class="macro-input" placeholder="0">
                                <span class="input-unit">g</span>
                              </div>
                              <div class="percentage-display">
                                <span class="percentage-value" *ngIf="activePlan.goals?.calories">{{(((activePlan.goals.fat ?? 0) * 9) / activePlan.goals.calories * 100) || 0 | number: '1.0-0'}}%</span>
                                <span class="percentage-value" *ngIf="!activePlan.goals?.calories">0%</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Carbs Card -->
                        <div class="macro-card carbs-card">
                          <div class="card-decoration"></div>
                          <div class="card-header">
                            <div class="macro-icon">
                              <ion-icon name="flash-outline"></ion-icon>
                            </div>
                            <h4>{{'general.carbs' | translate}}</h4>
                          </div>
                          <div class="card-body">
                            <div class="input-row">
                              <div class="input-wrapper">
                                <input type="number" inputmode="numeric" [(ngModel)]="activePlan.goals.carbs" (change)="saveMealPlan()" (ngModelChange)="macroChanged()" class="macro-input" placeholder="0">
                                <span class="input-unit">g</span>
                              </div>
                              <div class="percentage-display">
                                <span class="percentage-value" *ngIf="activePlan.goals?.calories">{{(((activePlan.goals.carbs ?? 0) * 4) / activePlan.goals.calories * 100) || 0 | number: '1.0-0'}}%</span>
                                <span class="percentage-value" *ngIf="!activePlan.goals?.calories">0%</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Calories Card -->
                        <div class="macro-card total-card">
                          <div class="card-decoration"></div>
                          <div class="card-header">
                            <div class="macro-icon">
                              <ion-icon name="flame-outline"></ion-icon>
                            </div>
                            <h4>{{'general.calories' | translate}}</h4>
                          </div>
                          <div class="card-body">
                            <div class="calorie-display">
                              <span class="calorie-number" *ngIf="activePlan.goals?.calories">{{activePlan.goals.calories | number:'1.0-0'}}</span>
                              <span class="calorie-number" *ngIf="!activePlan.goals?.calories">-</span>
                              <span class="calorie-unit">{{'mealPlanBuilder.kcalPerDay' | translate}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <!-- Meal Plan Builder Section (hidden for macro plans) -->
            <div *ngIf="!isMacroPlan">
              <div class="switchTabsInner">
                <ion-reorder-group (ionItemReorder)="reorderMeal($event)" disabled="false">
                  <div class="switchTabsFormDiv meal-container" *ngFor="let meal of activePlan.meals;let i=index;">
                    <div class="reportTable table3td table4td">
                      <div class="reportUL meal-header">
                        <div>
                          <p>
                            {{i + 1}}. {{meal.title}}
                            <span (click)="editMeal(i)">
                              <ion-icon name="create-outline"></ion-icon>
                            </span>
                          </p>
                        </div>

                        <div class="meal-actions">
                          <div class="inner">
                            <ion-button class="m-hide" size="small" fill="outline" color="secondary" (click)="editMealNotes(i)">
                              <ion-icon name="add-outline"></ion-icon> Info
                            </ion-button>
                            <ion-reorder>
                              <button>
                                <ion-icon size="small" name="swap-vertical-outline"></ion-icon>
                              </button>
                            </ion-reorder>
                            <button [matMenuTriggerFor]="mealMenu" class="m-hide">
                              <ion-icon size="small" name="copy-outline"></ion-icon>
                            </button>
                            <mat-menu #mealMenu="matMenu" yPosition="below">
                              <button mat-menu-item (click)="duplicateMeal(i)">{{'general.duplicateMeal' | translate}}</button>
                              <button mat-menu-item (click)="copyMealToMenu(meal)">{{'general.copytoMenu' | translate}}</button>
                            </mat-menu>
                            <button (click)="removeMeal(i)" class="m-hide">
                              <ion-icon size="small" name="trash-outline"></ion-icon>
                            </button>
                            <button [matMenuTriggerFor]="menu">
                              <ion-icon size="small" name="ellipsis-vertical"></ion-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                              <button mat-menu-item (click)="addMealOption(i)">
                                <span>{{'mealPlanBuilder.addMealOption' | translate}}</span>
                              </button>
                              <button class="d-hide" mat-menu-item (click)="duplicateMeal(i)">
                                <span>{{'general.duplicateMeal' | translate}}</span>
                              </button>
                              <button class="d-hide" mat-menu-item (click)="copyMealToMenu(meal)">
                                <span>{{'general.copyMealtoMenu' | translate}}</span>
                              </button>
                              <button class="d-hide" mat-menu-item (click)="editMealNotes(i)">
                                <span>{{'general.editMealNotes' | translate}}</span>
                              </button>
                              <!-- <button mat-menu-item (click)="editMeal(i)">
                                <span>Edit Meal title</span>
                              </button> -->
                              <!-- <button mat-menu-item (click)="duplicateMeal(i)">
                                <span>Duplicate meal</span>
                              </button> -->
                              <button mat-menu-item (click)="saveMealToLibrary(meal)">
                                <span>{{'general.saveMealToLib' | translate}}</span>
                              </button>
                              <button class="d-hide" mat-menu-item (click)="removeMeal(i)">
                                <span>{{'general.deleteMeal' | translate}}</span>
                              </button>
                            </mat-menu>
                          </div>
                        </div>
                      </div>
                      <div class="tableDiv1">

                        <meal-edit [userId]="programUserId" [foods]="foods" [recipes]="recipes" [meal]="meal" [userFoodPreferences]="userFoodPreferences" (updated)="saveMealPlan()" [mealIndex]="i" [activeMeals]="activeMeals"></meal-edit>

                      </div>
                    </div>
                  </div>
                </ion-reorder-group>

                <ion-button size="small" color="secondary" (click)="addMeal()" class="addCommonBtn">
                  <ion-icon name="add-outline"></ion-icon> {{'general.blankMeal' | translate}}
                </ion-button>

                <ion-button size="small" color="secondary" (click)="addSavedMeal()" class="addCommonBtn">
                  <ion-icon name="add-outline"></ion-icon> {{'general.savedMeal' | translate}}
                </ion-button>
              </div>
            </div>

            <!-- Plan Totals -->
            <div class="m-hide tableDiv1 plan-totals grantTotalTable" *ngIf="!isMacroPlan">
              <table class="tableStyle1 totalTable" style="width:100%;text-align:center;">
                <thead>
                  <tr>
                    <th class="m-hide"></th>
                    <th class="m-hide"></th>
                    <th>{{'general.proteins' | translate}}</th>
                              <th>{{'general.fats' | translate}}</th>
                              <th>{{'general.carbs' | translate}}</th>
                              <th>{{'general.sugars' | translate}}</th>
                              <th>{{'general.fibers' | translate}}</th>
                              <th>{{'general.calories' | translate}}</th>
                    <th></th>
                  </tr>

                </thead>
                <tbody>
                  <tr class="planTodal">
                    <td colspan="2" class="m-hide">{{'general.planTotal' | translate}}:</td>
                    <td>{{calculatePlanTotal(activePlan).protein | number:'1.0-0'}}g</td>
                    <td>{{calculatePlanTotal(activePlan).fat | number:'1.0-0'}}g</td>
                    <td>{{calculatePlanTotal(activePlan).carbs | number:'1.0-0'}}g</td>
                    <td>{{calculatePlanTotal(activePlan).sugar | number:'1.0-0'}}g</td>
                    <td>{{calculatePlanTotal(activePlan).fiber | number:'1.0-0'}}g</td>
                    <td>{{calculatePlanTotal(activePlan).calories | number:'1.0-0'}}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Plan Totals -->
          </div>

          <div class="meal-plan-empty-menus ion-padding ion-text-center" *ngIf="programMode !== 'menuLibrary' && (!activeMealPlan.plans || !activeMealPlan.plans.length)">
            <p class="empty-menus-title">{{'mealPlanBuilder.noMenusHeading' | translate}}</p>
            <p class="empty-menus-hint">{{'mealPlanBuilder.addMenuHint' | translate}}</p>
            <ion-button color="secondary" shape="round" (click)="newPlan()">
              <ion-icon slot="start" name="add-outline"></ion-icon>
              {{'mealPlanBuilder.createNewMenu' | translate}}
            </ion-button>
            <ion-button color="secondary" fill="outline" shape="round" (click)="addBlankPlan()">
              <ion-icon slot="start" name="add-outline"></ion-icon>
              {{'mealPlanBuilder.addBlankMenu' | translate}}
            </ion-button>
            <ion-button color="secondary" fill="outline" shape="round" (click)="addPlanFromLibrary()" *ngIf="organization?.isUserTrainer(activeUser?.uid) && !isMacroPlan">
              <ion-icon slot="start" name="library-outline"></ion-icon>
              {{'mealPlanBuilder.addMenuFromLibrary' | translate}}
            </ion-button>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ng-template>
<ion-footer class="d-hide" [class.macrosOpen]="isShown" *ngIf="activePlan && !isMacroPlan && appService.isMobile() && !isShown">
  <ion-toolbar brandingBackground="primaryColor">
    <div class="footer-drawer" [class.open]="footerDrawerExpanded" (touchstart)="onFooterDrawerTouchStart($event)" (touchend)="onFooterDrawerTouchEnd($event)" *ngIf="calculatePlanTotal(activePlan) as planTotals">
      <button type="button" class="drawer-handle-btn" (click)="toggleFooterDrawer()">
        <span class="drawer-handle"></span>
      </button>

      <table class="tableStyle1 totalTable">
        <thead>
          <tr>
            <th class="icon-col"></th>
            <th>{{'components.meal.cols.proteinAbbrev' | translate}}</th>
            <th>{{'components.meal.cols.fatAbbrev' | translate}}</th>
            <th>{{'components.meal.cols.carbsAbbrev' | translate}}</th>
            <th>{{'components.meal.cols.sugarAbbrev' | translate}}</th>
            <th>{{'components.meal.cols.fiberAbbrev' | translate}}</th>
            <th>{{'components.meal.cols.caloriesAbbrev' | translate}}</th>
            <th class="icon-col"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="icon-col"></td>
            <td>{{planTotals.protein | number:'1.0-0'}}g</td>
            <td>{{planTotals.fat | number:'1.0-0'}}g</td>
            <td>{{planTotals.carbs | number:'1.0-0'}}g</td>
            <td>{{planTotals.sugar | number:'1.0-0'}}g</td>
            <td>{{planTotals.fiber | number:'1.0-0'}}g</td>
            <td>{{planTotals.calories | number:'1.0-0'}}</td>
            <td class="icon-col"></td>
          </tr>
        </tbody>
      </table>

      <div class="remaining-section" *ngIf="footerDrawerExpanded">
        <div class="formula-separator"></div>
        <table class="tableStyle1 totalTable remaining-table formula-table">
          <tbody>
            <tr class="formula-remaining-row">
              <td class="icon-col"><ion-icon class="formula-row-icon" name="analytics-outline"></ion-icon></td>
              <td [class.positive]="(activePlan?.goals?.protein || 0) - (planTotals.protein || 0) >= 0" [class.negative]="(activePlan?.goals?.protein || 0) - (planTotals.protein || 0) < 0">
                <span class="remaining-pill">{{((activePlan?.goals?.protein || 0) - (planTotals.protein || 0)) | number:'1.0-0'}}g</span>
              </td>
              <td [class.positive]="(activePlan?.goals?.fat || 0) - (planTotals.fat || 0) >= 0" [class.negative]="(activePlan?.goals?.fat || 0) - (planTotals.fat || 0) < 0"><span class="remaining-pill">{{((activePlan?.goals?.fat || 0) - (planTotals.fat || 0)) | number:'1.0-0'}}g</span></td>
              <td [class.positive]="(activePlan?.goals?.carbs || 0) - (planTotals.carbs || 0) >= 0" [class.negative]="(activePlan?.goals?.carbs || 0) - (planTotals.carbs || 0) < 0"><span class="remaining-pill">{{((activePlan?.goals?.carbs || 0) - (planTotals.carbs || 0)) | number:'1.0-0'}}g</span></td>
              <td></td>
              <td></td>
              <td [class.positive]="(activePlan?.goals?.calories || 0) - (planTotals.calories || 0) >= 0" [class.negative]="(activePlan?.goals?.calories || 0) - (planTotals.calories || 0) < 0"><span class="remaining-pill">{{((activePlan?.goals?.calories || 0) - (planTotals.calories || 0)) | number:'1.0-0'}}</span></td>
              <td class="icon-col"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ion-toolbar>
</ion-footer>
<ng-template #elseBlock>
  -
</ng-template>